// Pages worth having ready: the ones almost everyone who can open them uses, so
// little of what is downloaded goes unused. Each page lists the permissions that
// let someone open it (any one is enough; none means everyone), so a page is only
// downloaded by the people who can use it. Order = most users first, so a short
// session still gets the pages most people need.
export const FREQUENT_PAGES = [
  { permissions: ["timekeeping.module"], load: () => import("../pages/MyTimesheet") },
  { permissions: ["timekeeping.module"], load: () => import("../pages/peopleHr/LeaveMockup") },
  { permissions: ["intel.view"], load: () => import("../pages/MorningBriefV2") },
  { permissions: ["leads.manual_screen_1"], load: () => import("../pages/TriageCenter") },
];

const SLOW_CONNECTIONS = new Set(["slow-2g", "2g", "3g"]);

export function canPreload(connection) {
  if (!connection) return true;
  return !connection.saveData && !SLOW_CONNECTIONS.has(connection.effectiveType);
}

export function pagesToPreload(pages, hasPermission) {
  return pages.filter(
    ({ permissions }) => permissions.length === 0 || permissions.some(hasPermission)
  );
}

function whenIdle(callback) {
  if (typeof window.requestIdleCallback === "function") {
    window.requestIdleCallback(callback, { timeout: 5000 });
  } else {
    window.setTimeout(callback, 2000);
  }
}

// One page per idle slot, so preloading never competes with what the user is doing.
// A failed download is ignored: opening the page loads it again and lazyPage
// handles a chunk replaced by a deploy.
function preloadInSequence(pages) {
  const [next, ...rest] = pages;
  if (!next) return;
  next.load()
    .catch(() => {})
    .finally(() => whenIdle(() => preloadInSequence(rest)));
}

let started = false;

export function preloadFrequentPages(hasPermission) {
  if (started) return;
  started = true;
  if (!canPreload(navigator.connection)) return;
  whenIdle(() => preloadInSequence(pagesToPreload(FREQUENT_PAGES, hasPermission)));
}
